(async() => {
    const { Core } = await importModule('Core');

    customElements.define('mini-nav', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]'
        }

        render() {
            if (this._navigationBound) return;
            this._navigationBound = true;
            this.returnTargets = [];
            this._syncLevels();
            this._handleNavigation();
        }

        _syncLevels() {
            [...this.$stage.children].forEach((level, index) => {
                const inactive = index !== Number(this.$stage.dataset.lvl);
                level.inert = inactive;
                level.setAttribute('aria-hidden', String(inactive));
            });
        }
        
        _handleNavigation() {
            this.$navItems.map(item => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    const current = Number(this.$stage.dataset.lvl);
                    const next = Number(item.dataset.toLvl);
                    if (item.dataset.choice) {
                        const radio = [...this.querySelectorAll('input')].find(input => input.id === item.dataset.choice);
                        if (radio) radio.checked = true;
                    }
                    if (next > current) this.returnTargets[current] = item;
                    this.$stage.dataset.lvl = item.dataset.toLvl;
                    this._syncLevels();
                    const level = this.$stage.children[next];
                    const target = next < current ? this.returnTargets[next] : [...level.querySelectorAll('a, button')].find(el => el.offsetParent !== null);
                    target?.focus({ preventScroll: true });
                })
            })
        }
    });
})()
